import React from 'react';
import { cn } from '../lib/utils';

export const ComicPanel = ({ children, className, hover = true, ...props }) => {
  return (
    <div
      className={cn(
        'bg-slate-800 border-4 border-black',
        'shadow-[4px_4px_0px_0px_#2FB4E9]',
        hover &&
          'hover:shadow-[6px_6px_0px_0px_#00E5E5] hover:translate-y-[-2px] transition-all duration-200',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const ComicButton = ({ children, variant = 'primary', className, ...props }) => {
  const variants = {
    primary:
      'text-[#041014] border-2 border-[#00FFFF] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]',
    secondary:
      'text-white border-2 border-[#2FB4E9] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]',
    blue:
      'text-white border-2 border-[#2FB4E9] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]',
    ghost:
      'bg-transparent hover:bg-slate-800 text-slate-300 hover:text-white border-2 border-slate-700 hover:border-[#2FB4E9]'
  };

  const styles = {
    primary: {
      background: 'linear-gradient(90deg, #00FFFF 0%, #00E5E5 50%, #00BFCF 100%)',
    },
    secondary: {
      background: '#2FB4E9',
    },
    blue: {
      background: '#2FB4E9',
    },
    ghost: {},
  };

  return (
    <button
      className={cn(
        'font-black uppercase tracking-wider py-4 px-8',
        'hover:translate-y-[-2px] transition-all duration-200',
        variants[variant],
        className
      )}
      style={styles[variant]}
      {...props}
    >
      {children}
    </button>
  );
};

export const ComicHeading = ({ children, className, as: Component = 'h2', ...props }) => {
  return (
    <Component
      className={cn(
        'font-black uppercase tracking-tighter italic text-white',
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
